import { HTMLAttributes } from 'react'

import Container from '@/components/base/container'
import Grid from '@/components/base/grid'
import Section from '@/components/base/section'
import Typography from '@/components/base/typography'

import { useQuoteMotion } from './motion/quote'

export type QuoteProps = HTMLAttributes<HTMLDivElement> &
  Partial<{
    paragraph: string
  }>

const Quote = ({ paragraph, ...props }: QuoteProps) => {
  const { motionRef } = useQuoteMotion()
  return (
    <Section ref={motionRef} {...props}>
      <Container>
        <Grid>
          <div className="col-span-2 md:col-span-6 lg:col-span-12">
            {paragraph ? (
              <Typography
                variant="big-quote"
                paragraph
                className="font-light [&_strong]:font-bold"
                data-motion-quote
              >
                {paragraph}
              </Typography>
            ) : null}
          </div>
        </Grid>
      </Container>
    </Section>
  )
}

export default Quote
